<div [ngClass]="readOnly ? 'project-address-left' : 'project-address-center'">
  <div *ngIf="readOnly">
    <b [innerHtml]="'INFORMATION'|translate">Information</b>
    <app-button-project-edit *ngIf="!disableEditionButton" [selectedStep]="0"></app-button-project-edit>
  </div>
  <form [formGroup]="projectForm" *ngIf="projectForm">
    <mat-form-field [ngClass]="dateStartIsLocked() ? 'readonly' : ''">
      <input matInput formControlName="start_date" [matDatepicker]="picker1" required
             placeholder="Start" [readonly]="dateStartIsLocked()">
      <mat-error *ngIf="start_date.invalid">{{getErrorMessageStartDate()}}</mat-error>
      <mat-datepicker-toggle matSuffix [for]="picker1" *ngIf="!dateStartIsLocked()"></mat-datepicker-toggle>
      <mat-datepicker #picker1></mat-datepicker>
    </mat-form-field>

    <mat-form-field [ngClass]="dateEndIsLocked() ? 'readonly' : ''">
      <input matInput formControlName="end_date" [matDatepicker]="picker2" required
             placeholder="End" [readonly]="dateEndIsLocked()">
      <mat-datepicker-toggle matSuffix [for]="picker2" *ngIf="!dateEndIsLocked()"></mat-datepicker-toggle>
      <mat-error *ngIf="end_date.invalid">{{getErrorMessageEndDate()}}</mat-error>
      <mat-datepicker #picker2></mat-datepicker>
    </mat-form-field>

    <br/>
    <mat-form-field [ngClass]="readOnly ? 'readonly' : ''">
      <input matInput [placeholder]="'NAME' | translate" formControlName="name" [readonly]="readOnly" required>
      <mat-error *ngIf="name.invalid">{{getErrorMessageName()}}</mat-error>
    </mat-form-field>

    <mat-form-field [ngClass]="readOnly ? 'readonly' : ''">
      <input matInput [placeholder]="'CODE' | translate" formControlName="code" [readonly]="readOnly" required>
      <mat-error *ngIf="code.invalid">{{getErrorMessageCode()}}</mat-error>
    </mat-form-field>

    <mat-form-field style="width:90%" [ngClass]="readOnly ? 'readonly' : ''">
      <input matInput [placeholder]="'DESCRIPTION' | translate" formControlName="description" [readonly]="readOnly">
      <mat-error *ngIf="description.invalid">{{getErrorMessageDescription()}}</mat-error>
    </mat-form-field>

    <mat-form-field style="width:90%" [ngClass]="readOnly ? 'readonly' : ''">
      <input matInput [placeholder]="'DOCUMENT_URL' | translate" formControlName="document_url" [readonly]="readOnly">
<!--      <mat-error *ngIf="description.invalid">{{getErrorMessageDescription()}}</mat-error>-->
    </mat-form-field>
    <mat-slide-toggle [disabled]="dateEndIsLocked()"
                      formControlName="archive">{{projectForm.value.archive ? ('ARCHIVE' | translate) :
      ('NO_ARCHIVE' | translate)}}
    </mat-slide-toggle>
  </form>
</div>
<br *ngIf="!readOnly" clear="left"/>
